import JwtBaseClient from './JwtBaseClient';

/**
 * @class RewardsClient
 *
 * @description API wrapper for Loyalty API
 */
class RewardsClient extends JwtBaseClient {
  constructor() {
    super(import.meta.env.VITE_REWARDS_URI);
  }

  async isRewardsProgramEligible(dealerId) {
    const response = await this.get(`/api/loyalty/eligibility/${dealerId}`);
    return response.data.eligible;
  }

  async getRewardsEnrollmentStatus() {
    const response = await this.get('/api/loyalty/v2/opt-in/status');
    return response.data;
  }

  async getRewardsProgramEligibility() {
    const response = await this.get('/api/loyalty/v2/eligibility');
    return response.data;
  }

  async joinLoyaltyProgram(dealerIdArray) {
    const requestBody = {
      dealer_ids: dealerIdArray,
    };
    const response = await this.post('/api/loyalty/v2/opt-in', requestBody);
    return response.data;
  }
}

export default RewardsClient;
